import {ArrayHelper} from "../helpers/array.helper";
import {comparator} from "../decorators/comparator.decorator";
import {ArrayComparator} from "./array.comparator";
import {Entity} from "../domain/entities/entity";
import {EntityObjectArray} from "../domain/entity-object-array";

@comparator(EntityObjectArray)
export class EntityObjectArrayComparator<T extends Entity = any> implements ArrayComparator<T> {

    public isEqualTo(value1: EntityObjectArray<T> | null, value2: EntityObjectArray<T> | null): boolean {
        if (!ArrayHelper.isEqual(value1, value2)) {
            return false;
        }

        // ArrayHelper.isEqual() returns false unless both arguments are arrays, so value2 is
        // non-null from here on.
        for (const objectFrom2 of value2!) {
            const objectFrom1 = (value1 ?? []).find(objectFrom1 => objectFrom1 === objectFrom2) ?? null;
            if (!objectFrom1) {
                return false;
            }

            if (ArrayHelper.intersect(objectFrom1.changedValues, objectFrom2.changedValues).length > 0) {
                return false;
            }

        }

        return true;
    }

}